export function formatToShortCst(dateTime: string): string {
  const date = new Date(dateTime);

  const optionsTime = {
    timeZone: 'America/Chicago',
    hour12: true,
    hour: 'numeric',
    minute: 'numeric',
  };

  const optionsDate = {
    timeZone: 'America/Chicago',
    month: 'short', // 'short' will give abbreviated month names (e.g., Jan, Feb)
    day: 'numeric',
  };

  // @ts-ignore
  return `${date.toLocaleDateString('en-US',optionsDate)} ${date.toLocaleTimeString('en-US', optionsTime)}`;
}
